import axios from "axios";
import { toast } from "react-toastify";

export const ApiDenuncia = axios.create({
  baseURL: process.env.REACT_APP_API_AUTH_URL,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});

ApiDenuncia.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const rawToken = sessionStorage.getItem("@auth_token_denuncia");

    if (rawToken && config?.headers) {
      const token = rawToken.replace(/"/g, "");
      config.headers.Authorization = `Token ${token}`;
    }
  }

  return config;
});

ApiDenuncia.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      toast.error("Token expirado");
      setTimeout(() => {
        sessionStorage.clear();
        window.location.href = "/";
      }, 2000);
    }

    return Promise.reject(error);
  }
);
